export enum TypesMailEnum {
    RAPPEL_OUVERTURE = 'rappel ouverture',
    OUVERTURE = 'ouverture',
    AJOUT_INTERVENANT = 'ajout intervenant',
    MAJ_DATE_LIMITE = 'maj date limite',
    STATUT_DELAI_DEPASSE = 'statut delai depasse',
    STATUT_FICHE_FINALISE = 'statut fiche finalise',
    RAPPEL_DELAI = 'rappel delai'
}